export const FILE_ICONS = {
    doc: "/images/icons/file/doc.png",
    json: "/images/icons/file/json.png",
    pdf: "/images/icons/file/pdf.png",
    xls: "/images/icons/file/xls.png",
    xlsx: "/images/icons/file/xls.png",
    xml: "/images/icons/file/xml.png",
    zip: "/images/icons/file/zip.png",
    default: "/images/icons/file/default.png",
  }